<template>
  <div class="my-accound">
    <h1>{{ $t("dashboard.account.account") }}</h1>
    <div class="links">
      <router-link to="/dashboard/goldlocker" active-class="active">
        <svg
          width="21"
          height="19"
          viewBox="0 0 21 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.1633 0.345704C8.03751 0.344985 5.96687 1.02198 4.25211 2.27837C2.53735 3.53475 1.26778 5.30508 0.627805 7.33223C-0.0121707 9.35938 0.0107767 11.5378 0.693314 13.551C1.37585 15.5642 2.68243 17.3074 4.42328 18.5274L4.63911 18.679H15.6874L15.9033 18.5274C17.6441 17.3074 18.9507 15.5642 19.6332 13.551C20.3158 11.5378 20.3387 9.35938 19.6987 7.33223C19.0588 5.30508 17.7892 3.53475 16.0744 2.27837C14.3597 1.02198 12.289 0.344985 10.1633 0.345704ZM15.1533 17.0124H5.17328C3.77163 15.9644 2.73549 14.5018 2.2118 12.8319C1.6881 11.162 1.70343 9.36961 2.25561 7.70891C2.80779 6.04822 3.8688 4.60352 5.28816 3.57969C6.70752 2.55586 8.41319 2.00488 10.1633 2.00488C11.9134 2.00488 13.619 2.55586 15.0384 3.57969C16.4578 4.60352 17.5188 6.04822 18.0709 7.70891C18.6231 9.36961 18.6385 11.162 18.1148 12.8319C17.5911 14.5018 16.5549 15.9644 15.1533 17.0124ZM16.8299 10.3457C16.8324 11.2334 16.6561 12.1126 16.3116 12.9308C15.9672 13.749 15.4616 14.4895 14.8249 15.1082L13.6583 13.9165C14.2944 13.2993 14.7533 12.5227 14.9871 11.6677C15.2208 10.8128 15.221 9.91074 14.9874 9.0557L16.2999 7.7432C16.6501 8.56616 16.8303 9.45136 16.8299 10.3457ZM5.16328 10.3457C5.16096 11.0111 5.29257 11.6701 5.55026 12.2836C5.80796 12.8971 6.18648 13.4524 6.66328 13.9165L5.49661 15.1082C4.3885 14.0214 3.69433 12.582 3.53377 11.0383C3.37321 9.49448 3.75633 7.94306 4.61708 6.6515C5.47783 5.35993 6.76225 4.40917 8.24888 3.96315C9.73552 3.51712 11.3312 3.60379 12.7608 4.2082L11.4533 5.5207C10.7129 5.319 9.93588 5.2911 9.18292 5.43918C8.42996 5.58726 7.7214 5.90732 7.11252 6.37438C6.50364 6.84145 6.01092 7.44288 5.6728 8.13176C5.33468 8.82064 5.1603 9.57833 5.16328 10.3457ZM11.7683 9.91904C11.8686 10.2797 11.8466 10.6634 11.7058 11.0102C11.565 11.357 11.3133 11.6474 10.99 11.8361C10.6668 12.0248 10.2901 12.1011 9.91887 12.0531C9.54765 12.0051 9.20277 11.8356 8.93809 11.5709C8.67341 11.3062 8.50384 10.9613 8.45586 10.5901C8.40787 10.2189 8.48418 9.84222 8.67286 9.51894C8.86155 9.19566 9.15198 8.94398 9.4988 8.80318C9.84563 8.66239 10.2293 8.64042 10.5899 8.7407L14.1574 5.1732L15.3358 6.35154L11.7683 9.91904Z"
          />
        </svg>
        <span>{{ $t("dashboard.account.summary") }}</span>
      </router-link>
      <router-link to="/dashboard/link-stripe" active-class="active">
        <svg
          width="21"
          height="17"
          viewBox="0 0 21 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.1631 11.3838C20.1631 14.3705 17.7331 16.8005 14.7464 16.8005H10.5798C7.59309 16.8005 5.16309 14.3705 5.16309 11.3838C5.16309 8.39712 7.59309 5.96712 10.5798 5.96712H11.8056C11.6914 6.91712 11.1689 7.63379 10.1631 7.63379C8.29975 7.85046 6.82975 9.46379 6.82975 11.3838C6.82975 13.4513 8.51225 15.1338 10.5798 15.1338H14.7464C16.8139 15.1338 18.4964 13.4513 18.4964 11.3838C18.4964 9.90212 17.6256 8.63046 16.3756 8.02212C16.5723 7.49629 16.7123 6.94296 16.7789 6.36629C18.7606 7.17212 20.1631 9.11629 20.1631 11.3838ZM1.82975 5.55046C1.82975 3.48296 3.51225 1.80046 5.57975 1.80046H9.74642C11.8139 1.80046 13.4964 3.48296 13.4964 5.55046C13.4964 7.47046 12.0264 9.08379 10.1631 9.30046C9.15725 9.30046 8.63475 10.0171 8.52059 10.9671H9.74642C12.7331 10.9671 15.1631 8.53712 15.1631 5.55046C15.1631 2.56379 12.7331 0.133789 9.74642 0.133789H5.57975C2.59309 0.133789 0.163086 2.56379 0.163086 5.55046C0.163086 7.81796 1.56559 9.76212 3.54725 10.568C3.61392 9.99129 3.75309 9.43879 3.95059 8.91212C2.70059 8.30296 1.82975 7.03212 1.82975 5.55046Z"
          />
        </svg>
        <span>{{ $t("dashboard.account.linkStripe") }}</span>
      </router-link>
      <router-link to="/dashboard/withdraw" active-class="active">
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2131_99171)">
            <path
              d="M10.1967 0.422061C15.7646 0.455468 20.2078 4.96549 20.1744 10.5557C20.141 16.0011 15.5976 20.4666 10.141 20.4221C4.53967 20.3775 0.129867 15.8898 0.163274 10.2996C0.196682 4.86527 4.74011 0.388653 10.1967 0.422061ZM10.1521 2.10358C5.50849 2.13698 1.78911 5.88977 1.82252 10.5C1.85592 15.0769 5.63098 18.7851 10.219 18.7628C14.8181 18.7405 18.5152 14.9878 18.504 10.3552C18.4929 5.81182 14.7067 2.07017 10.1521 2.10358Z"
            />
            <path
              d="M11.0094 15.4219C11.0094 15.7115 11.0094 15.9565 11.0094 16.2014C10.9871 16.736 10.6419 17.1035 10.1742 17.1035C9.70649 17.1035 9.36128 16.7471 9.33901 16.2126C9.33901 15.9676 9.33901 15.7226 9.33901 15.4219C8.96039 15.4219 8.62631 15.4442 8.29224 15.4219C7.05616 15.344 6.03166 14.2527 6.02052 13.0166C6.02052 12.5155 6.31006 12.1703 6.76663 12.1257C7.24547 12.0812 7.61295 12.3818 7.67977 12.883C7.76885 13.5288 8.03611 13.7738 8.68199 13.7738C9.68422 13.7738 10.6864 13.7738 11.6887 13.7738C12.3791 13.7738 12.6798 13.462 12.6798 12.7605C12.6798 11.4019 12.5573 11.2683 11.1876 11.2683C10.319 11.2683 9.43923 11.2683 8.57063 11.2683C7.1007 11.2683 6.04279 10.2104 6.02052 8.72929C6.02052 8.28385 5.99825 7.83842 6.0762 7.40412C6.29892 6.24599 7.29001 5.46648 8.51496 5.42194C8.77108 5.42194 9.0272 5.42194 9.33901 5.42194C9.33901 5.14354 9.33901 4.89855 9.33901 4.65356C9.36128 4.11904 9.69536 3.7627 10.1742 3.7627C10.653 3.7627 10.9871 4.11904 11.0094 4.65356C11.0205 4.88742 11.0094 5.12127 11.0094 5.42194C11.2989 5.42194 11.5662 5.42194 11.8334 5.42194C13.2254 5.46648 14.3056 6.50212 14.3279 7.81615C14.3279 8.35067 14.0272 8.72929 13.5484 8.75156C13.0918 8.77383 12.7466 8.45089 12.6798 7.93864C12.6018 7.35958 12.3346 7.10345 11.7555 7.10345C10.6976 7.10345 9.65081 7.10345 8.59291 7.10345C7.99157 7.10345 7.6909 7.42639 7.67977 8.02773C7.67977 8.23931 7.67977 8.43976 7.67977 8.65134C7.67977 9.26381 8.00271 9.58675 8.62631 9.59788C9.63968 9.59788 10.653 9.59788 11.6775 9.59788C13.3145 9.59788 14.339 10.6224 14.339 12.2482C14.339 12.6602 14.3501 13.0945 14.2722 13.4954C14.0272 14.6313 13.0807 15.3774 11.9225 15.4219C11.6441 15.4219 11.3546 15.4219 11.0205 15.4219H11.0094Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_2131_99171">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0.163086 0.421875)"
              />
            </clipPath>
          </defs>
        </svg>
        <span>{{ $t("dashboard.account.withdraw") }}</span>
      </router-link>
    </div>
    <hr />
    <div class="gcoins-balance">
      <div class="d-inline">
        <img src="../assets/gcoin.png" alt="GCoin" />
        <span class="title">{{ $t("dashboard.account.balance") }}</span>
        <p class="balance">1200</p>
      </div>
      <router-link
        to="/dashboard/recharge"
        class="btn btn-warning text-white px-4"
      >
        {{ $t("dashboard.goldlocker.recharge") }}
      </router-link>
    </div>
    <hr />
    <h1>{{ $t("dashboard.account.deposit") }}</h1>
    <div class="gcoins">
      <span>{{ $t("dashboard.account.GCoins") }}</span>
      <span class="balance">0</span>
    </div>
    <router-link
      to="/dashboard/security-deposit"
      class="btn btn-gold text-white px-5 my-3"
      >{{ $t("dashboard.account.add") }}</router-link
    >
    <p>{{ $t("dashboard.account.requirement") }}</p>
    <hr />
    <div class="d-inline upgrade">
      <router-link to="/dashboard/upgrade">
        <svg
          width="26"
          height="24"
          viewBox="0 0 26 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.212 1.36455C12.5114 0.443241 13.8148 0.44324 14.1141 1.36455L16.3063 8.11126C16.4402 8.52328 16.8241 8.80225 17.2573 8.80225H24.3512C25.32 8.80225 25.7227 10.0419 24.939 10.6113L19.1999 14.781C18.8495 15.0356 18.7028 15.487 18.8367 15.899L21.0288 22.6457C21.3282 23.567 20.2737 24.3331 19.49 23.7637L13.7509 19.594C13.4004 19.3394 12.9258 19.3394 12.5753 19.594L6.83621 23.7637C6.05249 24.3331 4.99801 23.567 5.29736 22.6457L7.4895 15.899C7.62338 15.487 7.47672 15.0356 7.12623 14.781L1.38714 10.6113C0.603423 10.0419 1.0062 8.80225 1.97492 8.80225H9.06883C9.50206 8.80225 9.88602 8.52328 10.0199 8.11126L12.212 1.36455Z"
            fill="#F6B317"
          />
        </svg>
        <h1>{{ $t("dashboard.account.upgrade") }}</h1>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
h1 {
  color: #4bc8bd;
  font-size: 1.5rem;
}
.links {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.5rem;
  a {
    color: #3b3e51;
    text-decoration: none;
    font-size: 1.15rem;
    svg {
      margin-right: 0.5rem;
      fill: #3b3e51;
    }
    span {
      vertical-align: middle;
    }
  }
  a.active {
    color: #a0afbe;
    svg {
      fill: #a0afbe;
    }
  }
}
hr {
  display: block;
  width: 100%;
  height: 1.2px;
  border: none;
  background-color: #a8c3ec5c;
}
.gcoins-balance {
  img {
    width: 20px;
    margin-right: 0.5rem;
  }
  .title {
    color: #3b3e51;
    font-size: 1.15rem;
    vertical-align: middle;
  }
  .balance {
    color: #1898dd;
    font-size: 1.5rem;
    font-weight: 600;
  }
}
.gcoins {
  color: #406d9a;
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.5rem;
  .balance {
    font-size: 2rem;
    line-height: 2rem;
  }
}
.upgrade {
  a {
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  svg {
    margin-right: 0.5rem;
  }
  h1 {
    color: #ef8200;
    font-size: 1.15rem;
    vertical-align: middle;
    margin: 0;
  }
}
</style>
